import { render, staticRenderFns } from "./unbindOTPTelegram.vue?vue&type=template&id=e68c32d2&scoped=true&lang=pug&"
import script from "./unbindOTPTelegram.vue?vue&type=script&lang=js&"
export * from "./unbindOTPTelegram.vue?vue&type=script&lang=js&"
import style0 from "./unbindOTPTelegram.vue?vue&type=style&index=0&id=e68c32d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68c32d2",
  null
  
)

export default component.exports